import { render, staticRenderFns } from "./IconsDialog.vue?vue&type=template&id=59400dc8&scoped=true&"
import script from "./IconsDialog.vue?vue&type=script&lang=js&"
export * from "./IconsDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconsDialog.vue?vue&type=style&index=0&id=59400dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59400dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59400dc8')) {
      api.createRecord('59400dc8', component.options)
    } else {
      api.reload('59400dc8', component.options)
    }
    module.hot.accept("./IconsDialog.vue?vue&type=template&id=59400dc8&scoped=true&", function () {
      api.rerender('59400dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/IconsDialog.vue"
export default component.exports